import './fdx-twofactor-form.styles.scss';
import FdxTwoFactorFormController from './fdx-twofactor-form.controller.js';

angular.module('feedAuthApp').component('fdxTwofactorForm', {
    template: require('./fdx-twofactor-form.template.html'),
    controller: FdxTwoFactorFormController
});